var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEsi = function SvgEsi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004586",
    d: "M21 17h-2V7h2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004586",
    fillRule: "evenodd",
    d: "M7.862 7H9v2H8c-.994 0-1.295.009-1.518.068a2 2 0 0 0-1.414 1.414C5.008 10.705 5 11.006 5 12s.009 1.295.068 1.518a2 2 0 0 0 1.414 1.414c.223.06.524.068 1.518.068h1v2H7.862c-.795 0-1.386 0-1.897-.136a4 4 0 0 1-2.829-2.829C3 13.524 3 12.933 3 12.138v-.276c0-.795 0-1.386.136-1.897a4 4 0 0 1 2.829-2.829C6.476 7 7.067 7 7.862 7",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#004586",
    fillRule: "evenodd",
    d: "M9 13H4v-2h5z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#004586",
    d: "M11 10a3 3 0 0 1 6 0h-2a1 1 0 1 0-1 1 3 3 0 1 1 0 6h-.182A2.818 2.818 0 0 1 11 14.182h2c0 .452.366.818.818.818H14a1 1 0 1 0 0-2 3 3 0 0 1-3-3"
  })));
};
export { SvgEsi as ReactComponent };
export default __webpack_public_path__ + "200c3c66cb3ed84bbb0f2022d22ea60d.svg";